import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Page from './components/page-component.vue';
  import { IProgram } from '@/types/program';

  export interface IProps {
    program: IProgram
  }
export default /*#__PURE__*/_defineComponent({
  props: {
    program: { default: () => ({} as IProgram) }
  },
  setup(__props: any) {

  ;

  

  // 调试用
  // import { ref, onMounted } from 'vue';
  // const program = ref<IProgram>({} as IProgram);
  // onMounted(async () => {
  //   const { request } = require('@/utils/index');
  //   const { data } = await request.get('programs/93');
  //   program.value = data;
  // });

  const cards = [
    {
      name: '수거 가능 품목',
      content: [
        {
          text: '샴푸류 · 세제통(세탁용) · 섬유유연제 <br class="d-block d-md-none"> <span class="d-none d-md-inline-block">·</span> 분무기(섬유/공기 탈취제)통'
        },
        {
          text: '플라스틱 방향제(화장실/차량용)류 · 칫솔'
        }
      ],
      tips: []
    },
    {
      name: '참여 방법',
      content: [
        {
          text: '1. 다 쓴 생활용품은 깨끗하게 세척 후<br class="d-block d-md-none"> 잘 건조해 주세요.'
        },
        {
          text: '<br class="d-block d-md-none">'
        },
        {
          text: '2. 모인 생활용품을 집에 있는 종이 박스에<br class="d-block d-md-none"> 포장해 문 앞에 놔주세요.'
        },
        {
          text: '<br class="d-block d-md-none">'
        },
        {
          text: '3. 가플지우 캠페인 사이트에서 해당하는 품목의<br class="d-block d-md-none"> 수거 신청하기 버튼을 클릭해주세요.'
        }
      ],
      tips: [
        {
          text: '- 수거품을 담는 박스는 가로*세로*높이 세 변의 합이<br class="d-block d-md-none"> 140cm 미만의 박스로 부탁드립니다.'
        },
        {
          text: '- 영업일 기준 3~4일 내로 택배기사님이 방문하시어 <br class="d-md-none">수거하실 예정입니다.'
        }
      ]
    },
    {
      name: '유의 사항',
      content: [
        {
          text: '‘수거 신청하기‘ 버튼을 클릭하실 때 마다<br class="d-block d-md-none"> <span class="strong">1개 박스에 대한 회수 신청</span>이 완료됩니다.'
        },
        {
          text: '회수 신청을 원하는 박스의 수가 1개 이상일 경우<br class="d-block d-md-none"> <span class="strong">박스의 수량만큼 신청</span>을 반복해주세요.'
        }
      ],
      tips: []
    }
  ];


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Page, {
    title: "[생활용품 플라스틱 재활용 참여 안내]",
    subtitle: "수거 신청 전 한 번 더 확인해주세요.",
    image: require('./images/program-1.png'),
    cards: cards,
    program: __props.program
  }, null, 8, ["image", "program"]))
}
}

})